import React, { useEffect, useState } from 'react'
import { ITransporterLight } from '../../types/transporter';
import { NavLink } from 'react-router-dom';
import { Button } from '@mui/material';

import { AppConfig } from '../../config/appConfig';
import { UtilityService } from '../../services/utilityService';

import { Icons } from '../icons';

export interface ITransporterTableProps {
	data?: ITransporterLight[];
	name?: string;
	state?: string;
	city?: string;
	status?: string;
	onFilteredResultsChanged?: (results: ITransporterLight[]) => void;
	onSortOptionschanged?: (sortField: string, sortAscending: boolean) => void;
}

const TransporterTable: React.FunctionComponent<ITransporterTableProps> = ({ data, name, state, city, status, onFilteredResultsChanged, onSortOptionschanged }) => {
	const [dataView, setDataView] = useState<ITransporterLight[]>([]);
	const [page, setPage] = useState(0);
	const [pageSize, setPageSize] = useState(AppConfig.defaultPageSize);
	const [sortField, setSortField] = useState(AppConfig.transporterListDefaultSortField);
	const [sortAscending, setSortAscending] = useState(true);

	useEffect(() => {
		if (data) {
			let newData = data.filter((item) => {
				if (name && !item.name?.toLowerCase()?.trim()?.includes(name.toLowerCase().trim())) {
					return false;
				}
				if (state && state != "All" && item.state != state) {
					return false;
				}
				if (city && city != "All" && item.city != city) {
					return false;
				}
				if (status && status != "All" && item.status != status) {
					return false;
				}
				return true;
			}).slice();

			if (sortField) {
				switch (sortField) {
					case "state": {
						newData.sort((a, b) => UtilityService.compareStrings(a.state, b.state));
						break;
					}
					case "city": {
						newData.sort((a, b) => UtilityService.compareStrings(a.city, b.city));
						break;
					}
					case "status": {
						newData.sort((a, b) => UtilityService.compareStrings(a.status, b.status));
						break;
					}
					default: {
						newData.sort((a, b) => UtilityService.compareStrings(a.name, b.name));
						break;
					}
				}
			}
			if (!sortAscending) newData.reverse();

			setDataView(newData);
			setPage(0);

			onFilteredResultsChanged?.(newData);
		}
	}, [data, name, state, city, status, sortField, sortAscending])

	useEffect(() => {
		onSortOptionschanged?.(sortField, sortAscending);
	}, [sortField, sortAscending])

	const handleHeaderClick = (field: string) => {
		if (sortField == field) {
			setSortAscending(!sortAscending);
		}
		else {
			setSortAscending(true);
			setSortField(field);
		}
	}

	const handlePageBack = () => {
		setPage(page - 1);
	}

	const handlePageForward = () => {
		setPage(page + 1);
	}

	return (
		<div className="hwi-entity-search-results-table">
			<div className="headers">
				<div className="name-col">
					<p onClick={() => handleHeaderClick("name")}>
						Name
						{" "}
						{(sortField == "name" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "name" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="city-col">
					<p onClick={() => handleHeaderClick("city")}>
						City
						{" "}
						{(sortField == "city" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "city" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="state-col">
					<p onClick={() => handleHeaderClick("state")}>
						State
						{" "}
						{(sortField == "state" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "state" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="status-col">
					<p onClick={() => handleHeaderClick("status")}>
						Status
						{" "}
						{(sortField == "status" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "status" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="controls-col">{""}</div>
			</div>
			<div className="data">
				{dataView?.length > 0 ?
					(
						dataView?.slice(page * pageSize, (page + 1) * pageSize).map((item) => (
							<div className="row" key={item.id}>
								<div className="name-col"><p>{item.name}</p></div>
								<div className="city-col"><p>{item.city}</p></div>
								<div className="state-col"><p>{item.state}</p></div>
								<div className="status-col"><p>{item.status}</p></div>
								<div className="controls-col"><p>
									<NavLink to={"/transporter/" + item.id}>
										<Icons.EditItem fill="#272f50" height="14px"></Icons.EditItem>
										{" "}
										Edit
									</NavLink>
								</p></div>
							</div>
						))
					) :
					(
						<div className="no-results">0 results</div>
					)
				}
			</div>
			{dataView?.length > 0 &&
				<div className="pager">
					<div className="pager-button"><Button variant="outlined" fullWidth={true} disabled={page < 1} onClick={handlePageBack}>Previous</Button></div>
					<div className="pager-text">{`${(page * pageSize) + 1} to ${((page + 1) * pageSize) <= dataView.length ? ((page + 1) * pageSize) : dataView.length} of ${dataView.length}`}</div>
					<div className="pager-button"><Button variant="outlined" fullWidth={true} disabled={((page + 1) * pageSize) >= dataView.length} onClick={handlePageForward}>Next</Button></div>
				</div>
			}
		</div>
	)
}

export default TransporterTable;